<template>
<div class="container bgray">
<div class="row bwhite" @click="toinfo">
	<div class="col-4" style="position:relative;">
	   <img :src="avatar" :alt="name" class="avatar" v-if="avatar">
	   <!-- <img src="images/a.jpg" alt=""class="avatar"> -->
	   <i class="fa fa-vcard avatar" v-if="!avatar"></i>
	</div>
	<div class="col-6 he">
		<p class="name">{{name}}</p>
		<p class="fy">{{hos}}</p>
	</div>
</div>

<div class="row bwhite">
	<router-link to="/user/order/1">
		<div class="col-33">
			<i class="fa fa-folder-open-o"></i>
			<p>全部订单</p>
		</div>
	</router-link>	
	<router-link to="/user/order/2">
		<div class="col-33">
			<i class="fa fa-credit-card"></i>
			<p>待付款</p>
		</div>
	</router-link>		
	<router-link to="/user/order/3">	
		<div class="col-33">
			<i class="fa fa-calendar"></i>
			<p>待预约</p>
		</div>
	</router-link>		
</div>

<div class="row">
	<ul class="list">
		<a class="item" href="#/user/report"><i class="fa fa-file-text-o blue"></i>报告查询<span class="fa fa-angle-right"></span></a>
        <a class="item" href="#/user/book"><i class="fa fa-calendar-check-o green"></i>体检预约<span class="fa fa-angle-right"></span></a>
		<a class="item" href="#/user/mybook"><i class="fa fa-calendar green"></i>我的预约<span class="fa fa-angle-right"></span></a>
        <a class="item" href="#/user/mycar"><i class="fa fa-shopping-cart red"></i>购物车<span class="fa fa-angle-right"></span></a>
        <a class="item" href="#/user/card"><i class="fa fa-credit-card green2"></i>卡券管理<span class="fa fa-angle-right"></span></a>
	    <a class="item" href="#/user/like"><i class="fa fa-heart-o orange"></i>收藏<span class="fa fa-angle-right"></span></a>
        <a class="item" href="#/user/family"><i class="fa fa-address-book-o bluered"></i>常用体检人<span class="fa fa-angle-right"></span></a>
	</ul>
</div>

</div>
</template>

<style scoped>
.avatar{width:80px;height:80px;border-radius: 50%;position: relative;top:1rem;left:2rem;}	
i.avatar{font-size:4rem;position:absolute;top:3.2rem;left:3rem;color:rgb(0,144,255); }
.he{height:110px;}
.name{font-size: 1.3rem;margin-top: 2.5rem;}
.fy{margin-top: .5rem;}
.col-33{height:100px;text-align: center;}
.col-33 i{color:rgb(0,144,255);margin:.5rem;font-size:2.5rem;}

.bgray{
	background: rgb(251,251,251);
	min-height: 93vh;
}
.bwhite{background: white;}
.green{color:rgb(0,191,122);}
.red{color:rgb(255,118,118);}
.orange{color:orange;}
.bluered{color:rgb(118,137,255);}
.green2{color:rgb(0,177,158);}
.list .item{padding:1rem 2.5rem;color:#adadad;font-size:1.1rem; }
.item i{margin-right: 1rem;font-size:1.8rem;position: relative;top:.15rem;}
.item span{font-size:1.5rem;float: right;margin-top: .2rem;}
</style>

<script>

export default{
   data(){
   	return {
   		mydata:mydata,
   		name:"",
   		avatar:"",
   		hos:"",
   	}
   },
   created:function(){
   	 this.mydata.nav="/";
   	 this.mydata.header=true;
   	 if(fun.islogin()){
	   	 this.name=fun.local("name");
	   	 this.avatar=fun.local("avatar");
	   	 this.hos=fun.local("hos");
   	 }else{
	   	 this.$router.push("/login");
   	 } 
   },
   methods:{
   	toinfo(){
   		if(fun.islogin()){
   			var path="/user/info";
   		}else{
   			var path="/login";
   		}
   		this.$router.push(path);
   	},
   }
}	
</script>


// WEBPACK FOOTER //
// src/components/user/index.vue